import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore"
import {  Link, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import RiderTripTable from '../../../components/table/RiderTripTable'
import { lightBlue } from '@mui/material/colors'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'
import { Breadcrumbs, Typography } from '@mui/material'

const Single = ({user}) => {

  const {staffId} = useParams()


  const [ staffData, setStaffData ] = useState("")

  const [openStatus, setOpenStatus] = useState(false)


  const getStaffInfo = () => {

    onSnapshot(doc(db, "staff", staffId), (doc) => {
  
     console.log("Current data: ", doc.data());
  
  
    setStaffData({id: doc.id, ...doc.data(), date: doc.data().timeStamp.toDate().toLocaleString()})
  
    
   });
  
  
  }

  useEffect(()=>{

    getStaffInfo()
    

  }, [])


  
    const handleStatus = async() => {
  
      
      const staffRef = doc(db, "staff", staffId);
  
      await updateDoc(staffRef, {
  
      status: staffData.status === "active" ? 'inactive' : 'active', 
  
   })
  
    setOpenStatus(false)
  
    }
  




  return (
    <>

<div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
          <div style={{display:'flex', alignSelf:'flex-end', justifyContent:'flex-end', marginRight:30, marginTop:20, marginBottom:20}}>
                    <Breadcrumbs aria-label="breadcrumb">
                      <Link underline="hover" color="inherit" href="/">
                        Home
                      </Link>
                      <Link
                        underline="hover"
                        color="inherit"
                        href="/staff"
                      >
                        Staff List
                      </Link>
                      <Typography color="green">Staff</Typography>
                    </Breadcrumbs>
          </div>
        <div className="top">
            
          <div className="left">
              <div style = {{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', paddingLeft:20, paddingRight:20, }}>
          
                      <h2 className='title'>Staff Information</h2>
                       <Link to={`/staff/edit/${staffId}`} 
                          style={{ border: '1px solid gray', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"", cursor:'pointer'}}>
                          <span style={{color:'black', fontWeight:'bold'}}>Edit Details</span>
                      </Link>
          
              </div>
            
            <div className='item'>
            <img
                src = {staffData.img ? staffData.img : "../images/user.png"}
                alt="avatar"
                style={{width:'100px', height:'100px', borderRadius:'50%'}}
                   
            /> 
               
                <div className="details">
                  <div style={{flexDirection:'row', alignItems:'center'}}>
                    <h3 className='itemTitle'>{staffData.firstname} {staffData.lastname}</h3>
                    {/* <span className='itemValue'>{`Driving Status: ${riderData.onlinestatus === "active"?"is online":"is offline"}`} </span> */}
                  </div>

                  <div className='detailItem'>
                    <span className='itemKey'>Telephone:</span>
                    <span className='itemValue'>{staffData.telephone}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Email:</span>
                    <span className='itemValue'>{staffData.email}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Address:</span>
                    <span className='itemValue'>{staffData.address}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>DOB:</span>
                    <span className='itemValue'>{staffData.dob}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Gender:</span>
                    <span className='itemValue'>{staffData.gender}</span>
                  </div>
                
                </div>

              

            </div>
          </div>
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <div style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>

                  <h2 className='title'>Staff Status</h2>

                  <a href="" onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:staffData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                          <span style={{color:'white', fontWeight:'bold'}}>{staffData.status === "active" ? "Active" : "Inactive"}</span>
                  </a>
              

            </div>


              <div style={{display:'flex', flexDirection:'row', gap:40, marginTop:50}}>
                    <span style={{fontWeight:'bold', color:'gray'}}>Staff Role:</span>
                    <span style={{color:'gray'}}>{staffData.role}</span>
                    
              </div>

                <div style={{display:'flex', flexDirection:'row', gap:40, marginTop:20}}>
                    <span style={{fontWeight:'bold', color:'gray'}}>Employment Date:</span>
                    <span style={{color:'gray'}}>{staffData.date}</span>
              </div>

          </div>
        
        </div>
      
        <div className="bottom">
         
        </div>
      </div>
     
    </div>
      <ConfirmStatusBox
        openStatus={openStatus}
        closeDialog={() => setOpenStatus(false)}
        statusFunction={handleStatus }
      />
    </>
 
  )
}

export default Single












// import React, { useEffect, useState } from 'react'
// import './single.scss'
// import Sidebar from '../../../components/sidebar/Sidebar'
// import Navbar from '../../../components/navbar/Navbar'
// import Chart from '../../../components/chart/Chart'
// import { doc, getDoc } from "firebase/firestore"
// import { useHistory, useParams } from "react-router-dom"
// import { db } from '../../../firebase'
// import RiderTripTable from '../../../components/table/RiderTripTable'

// const Single = ({rider}) => {

//   const {riderId} = useParams()


//   const [ riderData, setRiderData ] = useState("")

//   // const [ orderData, setOrderData ] = useState([])

//   const getRider = async() => {

//       const docRef = doc(db, "riders", riderId);

//       const docSnap = await getDoc(docRef);

    
      
//       if (docSnap.exists()) {

//         setRiderData(docSnap.data())
//         // console.log(riderData)
//       } else {
//         // doc.data() will be undefined in this case
//         console.log("No such document!");
//       }
//   }

//   useEffect(()=>{

//     getRider()

//   }, [])


//   // useEffect(() => {
    
//   //   //LISTEN REAL TIME

//   //   const orderQuery = async() => {

//   //     const orderRef = (collection(db, "order"));
//   //     const q = query(orderRef, where("riderId", "=="etRiderId));

//   //     const querySnapshot = await getDocs(q);
//   //       let list = []
//   //     querySnapshot.forEach((doc) => {
//   //       // doc.data() is never undefined for query doc snapshots
//   //       list.push(doc.data())
//   //       // console.log(doc.id, " => ", doc.data());
//   //       console.log(list)

//   //       setOrderData(list)
//   //       // console.log(orderData)
//   //     });

//   //     // setOrderData(doc.data())
//   //     // console.log(orderData)

//   //   }
    
//   //   orderQuery()   
//   // },[])
 

//   return (
//     <div className='single'>
//       <Sidebar/>
//       <div className='singleContainer'>
//         <Navbar/>
//         <div className="top">
//           <div className="left">
//             {/* <div className="editbutton">Edit</div> */}
//             <h2 className='title'>Rider Information</h2>
//             <div className='item'>
//             <img
//                 src = {riderData.riderPhoto ? riderData.riderPhoto : "../images/avatar.jpg"}
//                 alt="avatar"
//                 style={{width:'100px', height:'100px', borderRadius:'50%'}}
                   
//             /> 
              

          
               
//                 <div className="details">
//                   <h3 className='itemTitle'>{riderData.fullname}</h3>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Email:</span>
//                     <span className='itemValue'>{riderData.email}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Phone:</span>
//                     <span className='itemValue'>{riderData.telephone}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Date of Birth:</span>
//                     <span className='itemValue'>{riderData.dateOfBirth}</span>
//                   </div>
//                   {/* <div className='detailItem'>
//                     <span className='itemKey'>Registered:</span>
//                     <span className='iitemValue'>{riderData.timeStamp}</span>
//                   </div> */}
//                 </div>

//                 <div className="details">
//                   <div className='detailItem'>
//                     <span className='itemKey'>Gender:</span>
//                     <span className='itemValue'>{riderData.sex}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Date Joined:</span>
//                     {/* <span className='itemValue'>{riderData.timeStamp}</span> */}
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Status:</span>
//                     <span className='itemValue'>Active</span>
//                   </div>
//                   {/* <div className='detailItem'>
//                     <span className='itemKey'>Registered:</span>
//                     <span className='iitemValue'>{riderData.timeStamp}</span>
//                   </div> */}
//                 </div>
//             </div>
//           </div>
//           <div>
//             <Chart 
//               aspect={3/1}
//               title = "Rider purchase last 6 months"
//             />
//           </div>
//         </div>
//         <div className="bottom">
//         <div className='listTitle'>Rider Transactions History</div>
//           <RiderTripTable
//                 riderId = {riderId}
//           />
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Single